<template>
    <date-range-picker
        v-model="dateRange"
        @update="updateDateValues"
        :appendToBody="true"
        :locale-data="localeData"
        :autoApply="true"
        :singleDatePicker="singleDatePicker"
        :showDropdowns="false"
        :opens="opens"
        :ranges="ranges"
        :max-date="maxDate"
        ref="picker"
        control-container-class="dateRangePickerContainer"
    >
        <template v-slot:input="picker" style="min-width: 450px">
            <div class="input">
                {{ picker.startDate.toLocaleDateString().split(",")[0] }} -
                {{ picker.endDate.toLocaleDateString().split(",")[0] }}
            </div>
            <Loader v-if="loading" class="dateRangeLoadingSpinner" />
        </template>
    </date-range-picker>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import Loader from "@elems/loader.vue";

const moment = require("moment");

export default {
    name: "LocalDateRangePicker",
    components: {
        DateRangePicker,
        Loader
    },
    props: {
        initialRange: {
            type: Object,
            default: () => {
                return {
                    startDate: moment()
                        .startOf("month")
                        .toDate(),
                    endDate: moment()
                        .endOf("day")
                        .toDate()
                };
            }
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            singleDatePicker: "range",
            opens: "right",
            maxDate: new Date(),
            localeData: {
                direction: "ltr",
                format: "dd/mm/yyyy",
                separator: " - ",
                applyLabel: "Anvend",
                cancelLabel: "Annullér",
                weekLabel: "Uge",
                customRangeLabel: "Custom Range",
                daysOfWeek: ["Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"],
                monthNames: [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "Maj",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Okt",
                    "Nov",
                    "Dec"
                ],
                firstDay: 1
            }
        };
    },
    computed: {
        ranges: () => {
            let today = new Date();
            today.setHours(0, 0, 0, 0);

            return {
                Idag: [
                    moment()
                        .startOf("day")
                        .toDate(),
                    moment()
                        .endOf("day")
                        .toDate()
                ],
                "Denne uge": [
                    moment()
                        .startOf("week")
                        .toDate(),
                    moment()
                        .endOf("day")
                        .toDate()
                ],
                "Denne måned": [
                    moment()
                        .startOf("month")
                        .toDate(),
                    moment()
                        .endOf("day")
                        .toDate()
                ],
                "Dette år": [
                    moment()
                        .startOf("year")
                        .toDate(),
                    moment()
                        .endOf("day")
                        .toDate()
                ]
            };
        }
    },
    created() {
        moment.updateLocale("da", {
            week: {
                dow: 1
            }
        });
        this.dateRange = this.initialRange;
    },
    methods: {
        updateDateValues(values) {
            values.startDate = moment(values.startDate)
                .startOf("day")
                .toDate();
            values.endDate = moment(values.endDate)
                .endOf("day")
                .toDate();
            this.$emit("updateDate", values);
        }
    }
};
</script>

<style lang="scss" scoped>
.input {
    justify-content: center;
}

.calendars {
    flex-wrap: nowrap !important;
}
</style>

<style lang="scss">
.date-picker {
    padding-bottom: 0 !important;
}
.dateRangePickerContainer {
    position: relative;
}

.dateRangeLoadingSpinner {
    position: absolute;
    top: calc(50% + 2px);
    right: 10px;
    transform: translateY(-50%);
}
</style>
